import React from "react";
import { useHistory, Link } from "react-router-dom";
import { Button } from "react-bootstrap";
import { FileText, Briefcase, Clock } from "react-feather";
import TableComponent from "../../components/widgets/table/index";
import { useQuery } from "react-query";
import { api_srv } from "services";
import { listInvoices } from "services/apiSrv";

function ClientInvoices() {
  const history = useHistory();

  const get_invoices = async () => {
    let resp = await (await api_srv).fetchInvoices();
    console.log("resp invoices---", resp);
    return resp.data;
  };

  const {
    data: invoices,
    isLoading,
    isError,
    error,
    isFetching,
  } = useQuery({
    queryKey: ["invoices"],
    queryFn: get_invoices,
    staleTime: 5 * 60 * 1000,
    retry: 3,
  });

  if (isLoading || isFetching) {
    return <div>Loading invoices...</div>;
  }

  if (isError) {
    return <div>Error: {error.message}</div>;
  }

  const invoiceData = Array.isArray(invoices) ? invoices : [];

  const tableFields = [
    { name: "Invoice Reference" },
    { name: "Amount" },
    { name: "Status" },
    { name: "Created Date" },
    { name: "Action" },
  ];

  const tableRowData = [
    { type: "text", field: "invoiceSystemRef" },
    { type: "currency", field: "invoiceAmount" },
    { type: "status", field: "invoiceStatus" },
    { type: "date", field: "createdDate" },
    {
      type: "action",
      field: "id",
      actions: [
        {
          method: (id) => {
            history.push(`/dashboard/view-client-invoices/${id}`);
          },
          field: "id",
          title: "View",
        },
      ],
    },
  ];

  // Summary metrics
  const paidCount = invoiceData?.[0].items?.filter((inv) => inv.invoiceStatus === "PAID").length;
  const pendingCount = invoiceData?.[0].items?.filter((inv) => inv.invoiceStatus === "PENDING-PAYMENT").length;
  const overdueCount = invoiceData?.[0].items?.filter((inv) => inv.invoiceStatus === "EXPIRED").length;
  const totalAmount = invoiceData?.[0].items?.reduce((sum, inv) => sum + (inv.invoiceAmount || 0), 0);
  const paidAmount = invoiceData
    .filter((inv) => inv.invoiceStatus === "PAID")
    .reduce((sum, inv) => sum + (inv.invoiceAmount || 0), 0);
  const pendingOverdueAmount = invoiceData
    .filter((inv) => inv.invoiceStatus === "PENDING-PAYMENT" || inv.invoiceStatus === "EXPIRED")
    .reduce((sum, inv) => sum + (inv.invoiceAmount || 0), 0);

  // Format summary cards
  const summary = [
    {
      label: "Total Invoices",
      summary: invoiceData?.[0].items?.length,
      link: "#",
      icon: <FileText size={16} className="text-primary" />,
      amount: `${invoiceData[0]?.invoiceCurrency || "KES"} ${totalAmount.toLocaleString()}`,
    },
    {
      label: "Paid Invoices",
      summary: paidCount,
      link: "#",
      icon: <Briefcase size={16} className="text-success" />,
      amount: `${invoiceData[0]?.invoiceCurrency || "KES"} ${paidAmount.toLocaleString()}`,
    },
    {
      label: "Pending/Overdue",
      summary: pendingCount + overdueCount,
      link: "#",
      icon: <Clock size={16} className="text-warning" />,
      amount: `${invoiceData[0]?.invoiceCurrency || "KES"} ${pendingOverdueAmount.toLocaleString()}`,
    },
  ];

  return (
    <div className="#card #shadow p-4">
      <div className="mb-4">
        <div className="row row-xs clearfix">
          {summary.map((obj, idx) => (
            <div className="col-6 col-md-4" key={idx}>
              <Link to={obj.link}>
                <div
                  className="card mg-b-20 card-custom"
                  style={{
                    background: "#ffffff",
                    border: "none",
                    borderRadius: "8px",
                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                    padding: "20px",
                    textAlign: "left",
                  }}
                >
                  <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "8px" }}>
                    <span style={{ fontSize: "14px", fontWeight: 600, color: "#1a1a1a" }}>{obj.label}</span>
                    <div
                      style={{
                        width: "28px",
                        height: "28px",
                        background: "#e9ecef",
                        borderRadius: "6px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      {obj.icon}
                    </div>
                  </div>
                  <h2 style={{ fontSize: "24px", fontWeight: 700, color: "#1a1a1a" }}>
                    {obj.summary}
                  </h2>
                  <p style={{ fontSize: "14px", color: "#6c757d", marginBottom: 0 }}>{obj.amount}</p>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>

      {/* <div className="d-flex justify-content-between align-items-center mb-4">
        <Button
          variant="primary"
          size="lg"
          className="btn btn-primary btn-lg d-flex align-items-center"
        >
          New Invoice
        </Button>
      </div> */}

      <TableComponent
        title="Invoices"
        table_fields={tableFields}
        table_data={invoiceData[0]?.items}
        row_data={tableRowData}
        pageSize={10}
      />
    </div>
  );
}

export default ClientInvoices;
